var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-ikoner-navigation-engelska';
                    var viewUrl = 'gfx/sprite.svg#view-icon-ikoner-navigation-engelska';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };